import React from "react";
import { Form, InputGroup } from "react-bootstrap";
import { FormikProps } from "formik";
import { parseInitialYearSelectValue } from "../formSchema";
import { FormValues } from "../types";

const FormSwitch = (Form as any).Switch;

interface FreeMarketSectionProps {
  formik: FormikProps<FormValues>;
  demandaValid: boolean;
  buttonSelected: string;
  calculateEnergyPrice: (e: any) => void;
  changeTipoContratacao: (e: any) => void;
  changeSimulationPeriod: (initialYear: number, quantidadeAnos: number) => void;
  resetEnergyPrice: (value: string, index: number) => void;
  handleDefaultPrices: (e: any) => void;
  resetScarcity: (e: any) => void;
  resetEncargos: (e: any) => void;
}

export const FreeMarketSection = ({
  formik,
  demandaValid,
  buttonSelected,
  calculateEnergyPrice,
  changeTipoContratacao,
  changeSimulationPeriod,
  resetEnergyPrice,
  handleDefaultPrices,
  resetScarcity,
  resetEncargos,
}: FreeMarketSectionProps) => {
  const tipoContratacao = formik.values.tipoContratacao;

  return (
    <>
      <div>
        <div style={{ display: "flex", flexDirection: "column" }}>
          <span className="simulacao-form-header">Dados do mercado livre</span>
          <span style={{ color: "#7e7e82" }}>
            {tipoContratacao === "atacado"
              ? "Preços de energia recomendados para Atacadista"
              : "Preços de energia recomendados para Varejista"}
          </span>
        </div>
        <hr />
        {!formik.values.precoPadrao && (
          <span style={{ color: "red", fontSize: "12px" }}>
            O valor de energia que você está editando pode não refletir a
            realidade atual do mercado, recomenda-se a curva de energia sugerida
            pelo nosso sistema
          </span>
        )}
      </div>

      <div className="formLine">
        <Form.Group
          controlId="desconto"
          style={{ width: "100%", maxWidth: "375px", height: "80px" }}
        >
          <Form.Label className="simulacao-form-title">
            Desconto <span>*</span>
          </Form.Label>
          <Form.Control
            as="select"
            name="desconto"
            disabled={!demandaValid}
            placeholder="Porcentagem"
            onChange={(e: any) => {
              calculateEnergyPrice(e);
            }}
            onBlur={formik.handleBlur}
            value={formik.values.desconto}
          >
            <option value={-1} hidden>
              Selecione uma opção
            </option>
            <option value={0}>Energia sem desconto</option>
            <option value={0.5}>Energia com 50% de desconto</option>
            <option value={1}>Energia com 100% de desconto</option>
          </Form.Control>
          <span style={{ color: "red" }}>
            {formik.values.demandaForaPonta === "" ||
            formik.values.demandaForaPonta === "0"
              ? "Primeiro informe a demanda contratada"
              : formik.values.desconto === -1
              ? formik.errors.desconto
              : ""}
          </span>
        </Form.Group>

        <Form.Group
          controlId="simulationNumber"
          style={{ width: "100%", maxWidth: "375px", height: "80px" }}
        >
          <Form.Label className="simulacao-form-title">
            Selecionar ano de início da simulação
          </Form.Label>
          <Form.Control
            as="select"
            name="initialYear"
            disabled={!demandaValid}
            placeholder="Selecione o ano"
            onChange={(e: any) => {
              const initialYear = parseInitialYearSelectValue(e.target.value);
              changeSimulationPeriod(initialYear, formik.values.quantidadeAnos);
            }}
            onBlur={formik.handleBlur}
            value={formik.values.initialYear}
          >
            <option value={-1} hidden>
              Selecione uma opção
            </option>
            {Array.from({ length: 8 }, (_, i) => {
              const year = new Date().getFullYear() + i;
              return (
                <option key={year} value={year}>
                  {year}
                </option>
              );
            })}
          </Form.Control>
        </Form.Group>

        <Form.Group
          controlId="quantidadeAnos"
          style={{ width: "100%", maxWidth: "375px", height: "80px" }}
        >
          <Form.Label className="simulacao-form-title">
            Selecionar quantidade de anos da simulação
          </Form.Label>
          <Form.Control
            as="select"
            name="quantidadeAnos"
            disabled={!demandaValid}
            placeholder="Selecione a quantidade de anos"
            onChange={(e: any) => {
              const quantidadeAnos = Number(e.target.value);
              changeSimulationPeriod(
                Number(formik.values.initialYear),
                quantidadeAnos
              );
            }}
            onBlur={formik.handleBlur}
            value={formik.values.quantidadeAnos}
          >
            <option value={-1} hidden>
              Selecione uma opção
            </option>
            {Array.from({ length: 10 }, (_, i) => {
              return (
                <option key={i + 1} value={i + 1}>
                  {i + 1}
                </option>
              );
            })}
          </Form.Control>
        </Form.Group>
      </div>

      <div className="formLine">
        <Form.Group
          controlId="tipoContratacao"
          style={{ width: "100%", maxWidth: "375px", height: "80px" }}
        >
          <Form.Label className="simulacao-form-title">
            Tipo de contratação <span>*</span>
          </Form.Label>
          <Form.Control
            as="select"
            name="tipoContratacao"
            disabled={!demandaValid || buttonSelected !== "ML"}
            placeholder="Porcentagem"
            onChange={(e: any) => {
              changeTipoContratacao(e);
            }}
            onBlur={formik.handleBlur}
            value={formik.values.tipoContratacao}
          >
            <option value={"varejo"}>Varejista</option>
            <option value={"atacado"}>Atacadista</option>
          </Form.Control>
          <span style={{ color: "red" }}>
            {formik.values.demandaForaPonta === "" ||
            formik.values.demandaForaPonta === "0"
              ? "Primeiro informe a demanda contratada"
              : formik.errors.tipoContratacao}
          </span>
        </Form.Group>

        {Array.from({ length: formik.values.quantidadeAnos }, (_, i) => (
          <Form.Group
            key={i}
            controlId={`precoEnergia${i + 1}`}
            style={{ width: "100%", maxWidth: "375px", height: "80px" }}
          >
            <Form.Label className="simulacao-form-title">
              Preço da Energia {Number(formik.values.initialYear) + i}
            </Form.Label>
            <InputGroup className="mb-3">
              <InputGroup.Text>R$</InputGroup.Text>
              <Form.Control
                name="precoEnergia"
                disabled={formik.values.desconto === -1}
                placeholder="Em reais"
                onChange={(e: any) => {
                  formik.setFieldValue("precoPadrao", false);
                  resetEnergyPrice(e.target.value, i);
                }}
                onBlur={formik.handleBlur}
                value={formik.values.precoEnergia[i]}
                isInvalid={
                  !!formik.touched.precoEnergia &&
                  !!formik.errors.precoEnergia?.[i]
                }
              />
              <Form.Control.Feedback type="invalid">
                {formik.errors.precoEnergia?.[i]}
              </Form.Control.Feedback>
            </InputGroup>
          </Form.Group>
        ))}
      </div>

      <div className="formLine">
        <Form.Group
          controlId="precoPadrao"
          style={{
            width: "100%",
            maxWidth: "375px",
            height: "80px",
            display: "flex",
            gap: "32px",
          }}
        >
          <Form.Label className="simulacao-form-title">
            Usar preços sugeridos
          </Form.Label>
          <FormSwitch
            type="switch"
            name="precoPadrao"
            label=""
            value={formik.values.precoPadrao}
            onBlur={formik.handleBlur}
            onChange={(e: any) => handleDefaultPrices(e)}
            checked={formik.values.precoPadrao}
          />
        </Form.Group>

        <Form.Group
          controlId="isTaxScarcity"
          style={{
            width: "100%",
            maxWidth: "375px",
            height: "80px",
            display: "flex",
            gap: "32px",
          }}
        >
          <Form.Label className="simulacao-form-title">
            Paga Taxa escassez?
          </Form.Label>
          <FormSwitch
            type="switch"
            name="isTaxScarcity"
            label=""
            value={formik.values.isTaxScarcity}
            onBlur={formik.handleBlur}
            onChange={(e: any) => resetScarcity(e)}
            checked={formik.values.isTaxScarcity}
          />
        </Form.Group>

        <Form.Group
          controlId="isEncargos"
          style={{
            width: "100%",
            maxWidth: "375px",
            height: "80px",
            display: "flex",
            gap: "32px",
          }}
        >
          <Form.Label className="simulacao-form-title">
            Paga encargos?
          </Form.Label>
          <FormSwitch
            type="switch"
            name="isEncargos"
            label=""
            value={formik.values.isEncargos}
            onBlur={formik.handleBlur}
            onChange={(e: any) => resetEncargos(e)}
            checked={formik.values.isEncargos}
          />
        </Form.Group>
      </div>

      {/* <div className="formLine">
        <Form.Group
          controlId="isTaxCovid"
          style={{
            width: "100%",
            maxWidth: "375px",
            height: "80px",
            display: "flex",
            gap: "32px",
          }}
        >
          <Form.Label className="simulacao-form-title">
            Paga Taxa COVID?
          </Form.Label>
          <FormSwitch
            type="switch"
            name="isTaxCovid"
            label=""
            value={formik.values.isTaxCovid}
            onBlur={formik.handleBlur}
            onChange={(e: any) => resetCovid(e)}
            checked={formik.values.isTaxCovid}
          />
        </Form.Group>
      </div> */}
    </>
  );
};
